import TabbedPage from "src/components/TabbedPage";

// import User from "src/components/_ashboard/admin/user/User";
import Loadable from "src/components/loader/Loadable";
import { lazy } from "react";

import AdminContent from "src/components/dashboard/admin/Content/AdminContent";

import DashboardApp from "./DashboardApp";
import Emails from "src/pages/Emails";
import UserIssues from "../components/dashboard/admin/UserIssues";
import PopupConfig from "../components/dashboard/admin/Popup/PopupConfig";
import AdminGroups from "src/components/dashboard/admin/Group/AdminGroups";
import { useTranslation } from "react-i18next";

const User = Loadable(
    lazy(() => import("src/components/dashboard/admin/user/User"))
);

const Admin = () => {
    const { t } = useTranslation();
    return (
        <TabbedPage>
            <DashboardApp label={t('Admin.tabbedPages.dashboard')} />
            <User label={t('Admin.tabbedPages.users')} />
            <AdminContent label={t('Admin.tabbedPages.content')}>{t('Admin.tabbedPages.content')}</AdminContent>
            <Emails label={t('Admin.tabbedPages.emailTemplates')} />
            <UserIssues label={t('Admin.tabbedPages.userIssues')} />
            <PopupConfig label={t('Admin.tabbedPages.popupConfig')} />
            <AdminGroups label={t('Admin.tabbedPages.groups')} />
        </TabbedPage>
    );
};
export default Admin;
